import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const getToken = () => localStorage.getItem('token');

// Pega o depósito selecionado manualmente
const getSelectedDepositoId = () => {
  try {
    const selected = JSON.parse(localStorage.getItem('selectedDeposito') || '{}');
    return selected?.cod_dep || null;
  } catch {
    return null;
  }
};

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    // Token JWT
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Adiciona deposito_id por padrão nas query params
    const depositoId = getSelectedDepositoId();
    if (depositoId) {
      config.params = config.params || {};
      // não sobrescreve se já foi passado manualmente
      if (!config.params.deposito_id) {
        config.params.deposito_id = depositoId;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;

